import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Customer {
  id: number | null;
  name: string | null;
  accountId: number | null;
  description: string | null;
  context: string | null;
  directoryOptions: string | null;
  ringTimeoutSecs: number | null;
  type: string;
  fromCGS: boolean;
  status: string;
  defaultAreaCode: string | null;
  callLimit: number | null;
  callerName: string | null;
  callerNumber: string | null;
  e911CallerNumber: string | null;
  enableOutsideDial9: boolean;
  disableInternational: boolean;
  linePassword: string | null;
  linePasswordType: string;
  preferredCodec: string | null;
  devicePassword: string | null;
  devicePasswordType: string | null;
  disable411: boolean;
  restrictedPatterns: string | null;
  trustedNumbers: string | null;
  disableN11: boolean;
  disableOperatorAssist: boolean;
  stationNameType: string;
  stationNumberType: string;
  devprovIntervalSecs: number | null;
  directToVMPrefix: string | null;
  authPIN: string | null;
  timezone: string | null;
  checkoutPIN: string | null;
  enablePhoneDirectory: boolean;
  disableDomestic: boolean;
  VLANTag: string | null;
  useMegaDHCP: boolean;
  ppayMaxDurationSecs: number | null;
  ppayAnnounceCost: boolean;
  ppayAnnounceBalance: boolean;
  billAcctID: number | null;
  callrecMaxRetainMBs: number | null;
  callrecMaxRetainDays: number | null;
  disableMobile: boolean;
  disablePremium: boolean;
  disableInternationalUK: boolean;
  provisionKey: string | null;
  enableDashboard: boolean;
  seatLimit: number | null;
  didLimit: number | null;
  emerCallEmail: string | null;
  billingAcctID: string | null;
  vfaxPbxID: number | null;
  enableVfax: boolean;
  vfaxBeta: boolean;
  terminatedTime: string | null;
  tfLimit: number;
  callRecordRetainDays: number | null;
  locationID: number | null;
  ucaas: string;
  emergencyRoutingMethod: string;
  lidbOption: string;
  lidbSyncStatus: string;
  autoMailEnabled: boolean;
}

const initialState: Customer = {
  id: null,
  name: null,
  accountId: null,
  description: null,
  context: null,
  directoryOptions: null,
  ringTimeoutSecs: null,
  type: "business",
  fromCGS: false,
  status: "inactive",
  defaultAreaCode: null,
  callLimit: null,
  callerName: null,
  callerNumber: null,
  e911CallerNumber: null,
  enableOutsideDial9: true,
  disableInternational: false,
  linePassword: null,
  linePasswordType: "clear",
  preferredCodec: null,
  devicePassword: null,
  devicePasswordType: null,
  disable411: false,
  restrictedPatterns: null,
  trustedNumbers: null,
  disableN11: false,
  disableOperatorAssist: false,
  stationNameType: "custname",
  stationNumberType: "extension",
  devprovIntervalSecs: null,
  directToVMPrefix: null,
  authPIN: null,
  timezone: null,
  checkoutPIN: null,
  enablePhoneDirectory: true,
  disableDomestic: false,
  VLANTag: null,
  useMegaDHCP: false,
  ppayMaxDurationSecs: null,
  ppayAnnounceCost: true,
  ppayAnnounceBalance: true,
  billAcctID: null,
  callrecMaxRetainMBs: null,
  callrecMaxRetainDays: null,
  disableMobile: false,
  disablePremium: false,
  disableInternationalUK: false,
  provisionKey: null,
  enableDashboard: false,
  seatLimit: null,
  didLimit: null,
  emerCallEmail: null,
  billingAcctID: null,
  vfaxPbxID: null,
  enableVfax: false,
  vfaxBeta: false,
  terminatedTime: null,
  tfLimit: 0,
  callRecordRetainDays: null,
  locationID: null,
  ucaas: "no",
  emergencyRoutingMethod: "DLR",
  lidbOption: "NO_SYNC",
  lidbSyncStatus: "COMPLETE",
  autoMailEnabled: false,
};

export const customerChange = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer: (state, action: PayloadAction<Customer>) => {
      return { ...JSON.parse(JSON.stringify(action.payload)) };
    },
    clearCustomer: (state) => {
      return { ...initialState };
    },
  },
});

export const { setCustomer, clearCustomer } = customerChange.actions;

export default customerChange.reducer;
